import React from 'react';
import Style from '../../../styles/components/layout.module.css';
import { Link } from 'react-router-dom';
import AccessibleIcon from '../../icons/AccessibleIcon';
import Hr from '../../Hr';
import footerLang from '../../../data/lang/footer.lang';
import { useTags } from '../../../hooks/useTags';
import SmallSelectLanguage from './SmallSelectLanguage';
import useScreenSize from '../../../hooks/useScreenSize';
import { ShieldExclamation } from 'react-bootstrap-icons';
import { useProjectConfigContext } from '../../../contexts/ProjectConfigContext';



const Footer = () => {

    const { projectConfigState } = useProjectConfigContext();
    const { isMobileDevice } = useScreenSize();
    const is_mobile_device = isMobileDevice();
    const lolatechLogo = 'https://permit-public.s3.eu-central-1.amazonaws.com/logo-lolatech.png';

    const { projectId } = projectConfigState;
    var dateobj = new Date();

    const year = dateobj.getFullYear();
    const generateTag = useTags();
    const line1 = generateTag(footerLang, "line-1");
    const line2 = generateTag(footerLang, "line-2");
    const line3 = generateTag(footerLang, "line-3");
    const accesStatLong = generateTag(footerLang, "accessibilityStatement.long");
    const accesStatShort = generateTag(footerLang, "accessibilityStatement.short");
    const privacyPolicy = generateTag(footerLang, "privacyPolicy");

    return (
        <footer className={Style.footer}>

            <Hr height={2} mb={0} mt={0} />

            <div className={Style.footerContent}>

                <div className={Style.textContainers} style={{ flexGrow: 2 }}>
                    <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                        <Link to={`/accessibility-statement-page/${projectId}`}
                            className={Style.accessibilityStatementPage}>
                            <AccessibleIcon height="1.25rem" width="1.25rem" />
                            {is_mobile_device ? accesStatShort : accesStatLong}
                        </Link>
                        |
                        <Link to={`/privacy-policy/${projectId}`}
                            className={Style.accessibilityStatementPage}>
                            <ShieldExclamation height="1.15rem" width="1.15rem" />
                            {privacyPolicy}
                        </Link>
                        |
                        <SmallSelectLanguage />
                    </div>
                    <div className={Style.textItem}>
                        {line1}
                    </div>
                    <div className={Style.textItem}>
                        {line2}
                    </div>
                </div>

                <div className={Style.logoDivFooter} style={{ flexGrow: 0 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                        <img className={Style.logoFooter} src={lolatechLogo} alt='Lolatech Logo' />

                        <div className={Style.copyRightsText}>{line3} {year}</div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;